import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { getIsUserDropdownOpen } from '../redux/selectors';
import { closeNotificationsDropdown } from '../redux/actions';
import { Props } from './SiteHeaderMobile';

export type StateProps = Pick<Props, 'isLoggedIn' | 'isUserDropdownOpen'>;
export type DispatchProps = Pick<Props, 'closeNotificationsDropdown'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  isLoggedIn: getIsLoggedIn(state),
  isUserDropdownOpen: getIsUserDropdownOpen(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  closeNotificationsDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps);
